import {createYandexMapHelper} from "./yandex-map-helper/init-yandex-map";
import {YMAPS_API_KEY} from "./constants";
import {initFilters} from "./filters";
import {initPlacemarks} from "./placemarks";
import {initOverlayImage} from "./overlay";
import {initSpots} from "./spots";

const initInfrastructureMap = ( yandexMapHelper ) => {
	yandexMapHelper.addZoomControls( {
		position: {
			top: 20,
			right: 20,
			bottom: `auto`,
			left: `auto`,
		}
	} );
	yandexMapHelper.setCorrectScrolling();
	
	yandexMapHelper.yandexMap.margin.addArea( {
		left: 0,
		bottom: 0,
		width: `100%`,
		height: 100,
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		left: 0,
		width: `100%`,
		height: 100,
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		left: 0,
		width: 40,
		height: `100%`,
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		right: 0,
		width: 40,
		height: `100%`,
	} );
	
	initOverlayImage( yandexMapHelper );
	initSpots( yandexMapHelper );
	
	const managersByTypes = initPlacemarks( yandexMapHelper );
	initFilters( yandexMapHelper, managersByTypes );
};

const initSpotInfrastructure = () => {
	Array.from( document.querySelectorAll( `section.cds2-spot-infrastructure` ) )
		.forEach( ( component ) => {
			const mapContainer = component.querySelector( `div.map-container` );
			
			if ( mapContainer )
			{
				const mapProps = {
					ymapsApiKey: YMAPS_API_KEY,
					mapContainer,
					component,
					readyCallback: initInfrastructureMap,
				};
				
				createYandexMapHelper( mapProps );
			}
		} );
};

export {
	initSpotInfrastructure,
};
